import { render, staticRenderFns } from "./choseCoursePreview.vue?vue&type=template&id=15962ef8&scoped=true&"
import script from "./choseCoursePreview.vue?vue&type=script&lang=js&"
export * from "./choseCoursePreview.vue?vue&type=script&lang=js&"
import style0 from "./choseCoursePreview.vue?vue&type=style&index=0&id=15962ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15962ef8",
  null
  
)

export default component.exports